<div class="row">
    <div class="col-3" *ngIf="customFilter.state">
        <label for="state">State:</label>
    </div>
    <div class="col-3" *ngIf="customFilter.district">
        <label for="District">District:</label>
    </div>
    <div class="col-3" *ngIf="customFilter.status">
        <label for="District">Status:</label>
    </div>
</div>
<div class="row margin-bottom">
    <div class="col-3" *ngIf="customFilter.state">
        <select [compareWith]="showSelected" class="form-control" [(ngModel)]="modelObj.state" name="state" (change)="getDistricts()">
            <option value = ""  disabled>All</option>
            <option *ngFor="let state of states" [ngValue]="state">{{state.name}}</option>
        </select>
    </div>
    <div class="col-3" *ngIf="customFilter.district">
        <select [compareWith]="showSelected" class="form-control" [(ngModel)]="modelObj.district" name="district">
            <option value = "" disabled>All</option>
            <option *ngFor="let dist of districts" [ngValue]="dist">{{dist.name}}</option>
        </select>
    </div>
    <div class="col-3" *ngIf="customFilter.status">
        <select [compareWith]="showSelected" class="form-control" [(ngModel)]="modelObj.status" name="status">
            <option value="" disabled>All</option>
            <option *ngFor="let stat of status" [ngValue]="stat.name">{{stat.name}}</option>
        </select>
    </div>
</div>
<div class="row">
    <div class="col-3" *ngIf="customFilter.startDate">
        <label for="date">Start Date:</label>
    </div>
    <div class="col-3" *ngIf="customFilter.endDate">
        <label for="date">End Date:</label>
    </div>
    <div class="col-3" *ngIf="customFilter.keyword">
        <label for="date">Keyword Search:</label>
    </div>
</div>
<div class="row margin-bottom">
    <div class="col-3" *ngIf="customFilter.startDate">
        <div class="form-group m-form__group row">
            <div class="col-12">
                <input class="form-control m-input" placeholder="All" type="text" name="fullDate" [(ngModel)]="startDt" id="fullDate" #startDate>
            </div>
        </div>
    </div>
    <div class="col-3" *ngIf="customFilter.endDate">
        <div class="form-group m-form__group row">
            <div class="col-12">
                <input class="form-control m-input" placeholder="All" type="text" id="fullDate1" [(ngModel)]="endDt" #endDate>
            </div>
        </div>
    </div>
    <div class="col-3" *ngIf="customFilter.keyword">
        <div class="form-group m-form__group row">
            <div class="col-12">
                <input class="form-control m-input" type="text" placeholder="Search by Rozgar Mela ID" id="Search" name="KeywordSearch" [(ngModel)]="modelObj.keyword">
            </div>
        </div>
    </div>
    <div class="col-3">
        <button type="button" class="btn btn-primary apply-filter-btn" (click)="applyFilters()">
			Apply Filters
        </button>
        <button type="button" class="btn btn-secondary" (click)="reset()">
			Reset
        </button>
    </div>
</div>